import Vue from "vue";
import Vuex from "vuex";
import cloneDeep from "lodash/cloneDeep";

import auth from "./modules/auth";
import settings from "./modules/settings";
import businessAddresses from "./modules/businessAddresses";
import websites from "./modules/websites";
import company from "./modules/company";
import keywords from "./modules/keywords";
import locations from "./modules/locations";
import reviews from "./modules/reviews";
import facilities from "./modules/facilities";
import facilitiesGroups from "./modules/facilitiesGroups";
import attributes from "./modules/attributes";
import permissions from "./modules/permissions";
import externalChanges from "./modules/externalChanges";
import reviewsCategoriesAnalytics from "./modules/reviewsCategoriesAnalytics";
import payments from "./modules/payments";
import questionsAndAnswers from "./modules/questionsAndAnswers";
import posts from "./modules/posts";
import keywordImpressions from "./modules/keywordImpressions";

Vue.use(Vuex);
const initialState = cloneDeep({
  auth: { ...auth.state },
  settings: { ...settings.state },
  businessAddresses: { ...businessAddresses.state },
  websites: { ...websites.state },
  company: { ...company.state },
  keywords: { ...keywords.state },
  locations: { ...locations.state },
  reviews: { ...reviews.state },
  facilities: { ...facilities.state },
  facilitiesGroups: { ...facilitiesGroups.state },
  attributes: { ...attributes.state },
  permissions: { ...permissions.state },
  externalChanges: { ...externalChanges.state },
  reviewsCategoriesAnalytics: { ...reviewsCategoriesAnalytics.state },
  payments: { ...payments.state },
  questionsAndAnswers: { ...questionsAndAnswers.state },
  posts: { ...posts.state },
  keywordImpressions: { ...keywordImpressions.state }
});
// Auth state may have been hydrated from localStorage when the app started.
initialState.auth.user = { token: "", email: "" };

export const store = new Vuex.Store({
  modules: {
    auth,
    settings,
    businessAddresses,
    websites,
    company,
    keywords,
    locations,
    reviews,
    facilities,
    facilitiesGroups,
    attributes,
    permissions,
    externalChanges,
    reviewsCategoriesAnalytics,
    payments,
    questionsAndAnswers,
    posts,
    keywordImpressions
  },
  mutations: {
    CLEAR_STORE(state) {
      const selectedLocale = state.settings.selectedLocale;
      Object.keys(initialState).forEach(key => {
        Object.assign(state[key], cloneDeep(initialState[key]));
      });
      state.settings.selectedLocale = selectedLocale;
    }
  }
});
